import { Routes } from '@angular/router';
import { LoginComponent } from './login/login';
import { RegisterComponent } from './register/register';
import { NonMnfgRegisterComponent } from './register/non-mnfg-register/non-mnfg-register';
// Force TS Server re-evaluation
import { TradeRegisterComponent } from './register/trade-register/trade-register';
import { authGuard, loginGuard } from './core/guards/auth.guard';
import { UserPreview } from './user-preview/user-preview';
import { ROLES } from './core/constants/roles';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  {
    path: 'track-application',
    loadComponent: () =>
      import('./login/track-application/track-application').then(
        (m) => m.TrackApplicationComponent,
      ),
  },
  {
    path: 'register/preview/:applicationNo/:referenceNo',
    component: UserPreview,
  },
  {
    path: 'regview',
    component: UserPreview,
  },
  { path: 'register', component: RegisterComponent },
  { path: 'non-mnfg-register', component: NonMnfgRegisterComponent },
  { path: 'trade-register', component: TradeRegisterComponent },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin-dashboard/admin-layout/admin-layout').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [authGuard],
    data: { roles: [ROLES.ADMIN] },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/admin-dashboard/admin-dashboard').then(
            (m) => m.AdminDashboardComponent,
          ),
      },
      {
        path: 'masters/create-user',
        loadComponent: () =>
          import('./features/admin-dashboard/masters/create-user/create-user').then(
            (m) => m.CreateUserComponent,
          ),
      },
      {
        path: 'masters/edit-user/:id',
        loadComponent: () =>
          import('./features/admin-dashboard/masters/create-user/create-user').then(
            (m) => m.CreateUserComponent,
          ),
      },
      {
        path: 'masters/user-list',
        loadComponent: () =>
          import('./features/admin-dashboard/masters/user-list/user-list').then(
            (m) => m.UserListComponent,
          ),
      },
    ],
  },
  {
    path: 'vendor',
    loadComponent: () =>
      import('./features/vendor-dashboard/vendor-dashboard').then(
        (m) => m.VendorDashboardComponent,
      ),
    canActivate: [authGuard],
    data: { roles: [ROLES.VENDOR] },
  },
  {
    path: 'member',
    loadComponent: () =>
      import('./features/member-dashboard/member-layout/member-layout').then((m) => m.MemberLayout),
    canActivate: [authGuard],
    data: { roles: [ROLES.MEMBER_COMMITTEE] },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/member-dashboard/member-dashboard').then(
            (m) => m.MemberDashboardComponent,
          ),
      },
      {
        path: 'registrations',
        loadComponent: () =>
          import('./features/member-dashboard/registration-list/registration-list').then(
            (m) => m.RegistrationList,
          ),
      },
      {
        path: 'advance-payment',
        loadComponent: () =>
          import('./features/vendor-dashboard/advance-payment/advance-payment').then(
            (m) => m.AdvancePayment,
          ),
      },
      {
        path: 'advance-payment/add',
        loadComponent: () =>
          import('./features/vendor-dashboard/advance-payment/advance-payment-form').then(
            (m) => m.AdvancePaymentForm,
          ),
      },
      // {
      //   path: 'settings',
      //   loadComponent: () =>
      //     import('./features/member-dashboard/member-settings/member-settings').then(
      //       (m) => m.MemberSettings,
      //     ),
      // },
    ],
  },
  {
    path: 'chief',
    loadComponent: () =>
      import('./features/chief-dashboard/chief-layout/chief-layout').then((m) => m.ChiefLayout),
    canActivate: [authGuard],
    data: { roles: [ROLES.CHIEF_ENGINEER] },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/chief-dashboard/chief-dashboard').then(
            (m) => m.ChiefDashboardComponent,
          ),
      },
      {
        path: 'allocation/ce',
        loadComponent: () =>
          import('./features/chief-dashboard/ce-allocation/ce-allocation').then(
            (m) => m.CeAllocation,
          ),
      },
      {
        path: 'allocation/history',
        loadComponent: () =>
          import('./features/chief-dashboard/allocation-history/allocation-history').then(
            (m) => m.AllocationHistory,
          ),
      },

      {
        path: 'settings/users',
        loadComponent: () =>
          import('./features/chief-dashboard/chief-settings/chief-settings').then(
            (m) => m.ChiefSettings,
          ),
        data: {
          title: 'User Management',
          icon: 'bi-people-fill',
          description: 'Manage portal users, roles and access permissions.',
        },
      },
      // {
      //   path: 'settings/configuration',
      //   loadComponent: () =>
      //     import('./features/chief-dashboard/chief-settings/chief-settings').then(
      //       (m) => m.ChiefSettings,
      //     ),
      //   data: {
      //     title: 'Configuration',
      //     icon: 'bi-toggles',
      //     description: 'Configure system parameters and allocation settings.',
      //   },
      // },
      {
        path: 'committee/:id/registrations',
        loadComponent: () =>
          import('./features/chief-dashboard/committee-registrations/committee-registrations').then(
            (m) => m.CommitteeRegistrationsComponent,
          ),
      },
      {
        path: 'inspection-allocation',
        loadComponent: () =>
          import('./features/chief-dashboard/ce-inspection-allocation/ce-inspection-allocation').then(
            (m) => m.CeInspectionAllocation,
          ),
      },
      {
        path: 'masters/inspection-groups',
        loadComponent: () =>
          import('./features/chief-dashboard/ce-inspection-group/ce-inspection-group').then(
            (m) => m.CeInspectionGroup,
          ),
        data: { title: 'Inspection Groups', icon: 'bi-people-fill' },
      },
      {
        path: 'ash-dashboard',
        loadComponent: () =>
          import('./features/chief-dashboard/ce-ash-dashboard/ce-ash-dashboard').then(
            (m) => m.CeAshDashboard,
          ),
      },
      {
        path: 'ash-dashboard/:ashRequestId',
        loadComponent: () =>
          import('./features/chief-dashboard/ce-ash-details/ce-ash-details').then(
            (m) => m.CeAshDetails,
          ),
      },
    ],
  },
  {
    path: 'officer',
    loadComponent: () =>
      import('./features/officer-dashboard/officer-layout/officer-layout').then(
        (m) => m.OfficerLayout,
      ),
    canActivate: [authGuard],
    data: { roles: [ROLES.ASH_HANDLING_OFFICER] },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/officer-dashboard/officer-dashboard').then(
            (m) => m.OfficerDashboardComponent,
          ),
      },
      {
        path: 'allocation/daily',
        loadComponent: () =>
          import('./features/officer-dashboard/daily-allocation/daily-allocation').then(
            (m) => m.DailyAllocation,
          ),
      },
      {
        path: 'allocation/reallocation-eligible',
        loadComponent: () =>
          import('./features/officer-dashboard/reallocation-eligible-users/reallocation-eligible-users').then(
            (m) => m.ReallocationEligibleUsersComponent,
          ),
      },
      {
        path: 'allocation/history',
        loadComponent: () =>
          import('./features/officer-dashboard/allocation-list/allocation-list').then(
            (m) => m.AllocationList,
          ),
      },
      {
        path: 'allocation/status',
        loadComponent: () =>
          import('./features/officer-dashboard/allocation-status/allocation-status').then(
            (m) => m.AllocationStatus,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/officer-dashboard/officer-settings/officer-settings').then(
            (m) => m.OfficerSettings,
          ),
      },
      {
        path: 'user-transaction',
        loadComponent: () =>
          import('./features/officer-dashboard/user-transaction/user-transaction').then(
            (m) => m.UserTransaction,
          ),
      },
      {
        path: 'gate-pass',
        loadComponent: () =>
          import('./features/chief-dashboard/gate-pass/gate-pass-list/gate-pass-list').then(
            (m) => m.GatePassListComponent,
          ),
      },
      {
        path: 'gate-pass/create',
        loadComponent: () =>
          import('./features/chief-dashboard/gate-pass/gate-pass-create/gate-pass-create').then(
            (m) => m.GatePassCreateComponent,
          ),
      },
      {
        path: 'lifting-process',
        loadComponent: () =>
          import('./features/chief-dashboard/lifting-process/lifting-process-list/lifting-process-list').then(
            (m) => m.LiftingProcessListComponent,
          ),
      },
      {
        path: 'lifting-process/create',
        loadComponent: () =>
          import('./features/chief-dashboard/lifting-process/lifting-process-create/lifting-process-create').then(
            (m) => m.LiftingProcessCreateComponent,
          ),
      },
      {
        path: 'delivery-process',
        loadComponent: () =>
          import('./features/chief-dashboard/delivery-process/delivery-process-list/delivery-process-list').then(
            (m) => m.DeliveryProcessListComponent,
          ),
      },
      {
        path: 'delivery-process/create',
        loadComponent: () =>
          import('./features/chief-dashboard/delivery-process/delivery-process-create/delivery-process-create').then(
            (m) => m.DeliveryProcessCreateComponent,
          ),
      },
    ],
  },
  {
    path: 'inspection',
    loadComponent: () =>
      import('./features/inspection-dashboard/inspection-layout/inspection-layout').then(
        (m) => m.InspectionLayout,
      ),
    canActivate: [authGuard],
    data: { roles: [ROLES.INSPECTION] },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/inspection-dashboard/inspection-dashboard/inspection-dashboard').then(
            (m) => m.InspectionDashboardComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
